import React, { useState, useEffect, useContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Progressbar from '@material-ui/core/LinearProgress';
import axios from '../../../../../api/axios';
import { store } from '../../../../../store';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 500,
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > div:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const CommissionsParams = () => {
  useTitle('پارامتر های کمیسیون')
  const classes = useStyles();
  const { showMessage, showError } = useContext(store);
  const [params, setParams] = useState({});
  const {
    VAT,
    terminalShare,
    supplementaryInsurance,
    customersShareFromCommission,
    driversShareFromCommission,
    operatorsShareFromCommission,
  } = params;
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!VAT) {
      er.VAT = 'درصد مالیات بر ارزش افزوده را وارد نمائید.';
    }
    if (!terminalShare) {
      er.terminalShare = 'درصد مالیات بر ارزش افزوده را وارد نمائید.';
    }
    if (!supplementaryInsurance) {
      er.supplementaryInsurance = 'درصد مالیات بر ارزش افزوده را وارد نمائید.';
    }
    if (!customersShareFromCommission) {
      er.customersShareFromCommission =
        'درصد سهم صاحبین‌بار از کمیسیون را وارد نمائید.';
    }
    if (!driversShareFromCommission) {
      er.driversShareFromCommission =
        'درصد سهم رانندگان از کمیسیون را وارد نمائید.';
    }
    if (!operatorsShareFromCommission) {
      er.operatorsShareFromCommission =
        'درصد سهم کارشناسان حمل از کمیسیون را وارد نمائید.';
    }

    // Validation patterns end here.

    if (isSingleValidation) {
      let err = {};

      for (const v in params) {
        if (params[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        setErrors(err);
        return false;
      }
      {
        setErrors({});
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        setErrors(er);
        return false;
      }
      setErrors(er);
      return true;
    }
  };
  const handleChage = (e) => {
    const { name, value } = e.target;
    setParams((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async () => {
    if (!validation()) return;
    try {
      axios.put(`/api/v1/admin/settings`, {
        settings: params,
        section: 'commissions',
      });
      showMessage('تنظیمات با موفقیت ذخیره گردید.');
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`/api/v1/admin/settings/commissions`);
        if (data && data.settings) {
          setParams(data.settings);
        }
        setLoading(false);
      } catch (error) {
        showError(error);
      }
    })();
  }, []);

  return (
    <FullCard
      title="پارامترهای کمیسیون"
      category="تنظیم پارامترهای موثر در محاسبه کمیسیون بار"
    >
      {loading ? (
        <Progressbar />
      ) : (
        <div className={classes.root}>
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            label="درصد مالیات بر ارزش افزوده"
            name="VAT"
            onChange={handleChage}
            error={errors.VAT ? true : false}
            helperText={errors.VAT ? errors.VAT : ''}
            value={VAT ? VAT : ''}
            onBlur={validation}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            label="درصد حق پایانه دولت"
            onChange={handleChage}
            name="terminalShare"
            error={errors.terminalShare ? true : false}
            helperText={errors.terminalShare ? errors.terminalShare : ''}
            value={terminalShare ? terminalShare : ''}
            onBlur={validation}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            name="supplementaryInsurance"
            label="درصد بیمه تکمیلی"
            onChange={handleChage}
            value={supplementaryInsurance ? supplementaryInsurance : ''}
            error={errors.supplementaryInsurance ? true : false}
            helperText={
              errors.supplementaryInsurance ? errors.supplementaryInsurance : ''
            }
            onBlur={validation}
          />
          <Divider style={{ marginBottom: 10 }} />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            name="customersShareFromCommission"
            label="درصد سهم صاحبین بار از کمیسیون"
            onChange={handleChage}
            value={
              customersShareFromCommission ? customersShareFromCommission : ''
            }
            error={errors.customersShareFromCommission ? true : false}
            helperText={
              errors.customersShareFromCommission
                ? errors.customersShareFromCommission
                : ''
            }
            onBlur={validation}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            name="driversShareFromCommission"
            label="درصد سهم رانندگان از کمیسیون"
            onChange={handleChage}
            value={driversShareFromCommission ? driversShareFromCommission : ''}
            error={errors.driversShareFromCommission ? true : false}
            helperText={
              errors.driversShareFromCommission
                ? errors.driversShareFromCommission
                : ''
            }
            onBlur={validation}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            name="operatorsShareFromCommission"
            label="درصد سهم کارشناسان حمل از کمیسیون"
            onChange={handleChage}
            value={
              operatorsShareFromCommission ? operatorsShareFromCommission : ''
            }
            error={errors.operatorsShareFromCommission ? true : false}
            helperText={
              errors.operatorsShareFromCommission
                ? errors.operatorsShareFromCommission
                : ''
            }
            onBlur={validation}
          />
          <div>
            <Button
              variant="contained"
              fullWidth
              color="secondary"
              size="large"
              onClick={handleSubmit}
            >
              ذخیره
            </Button>
          </div>
        </div>
      )}
    </FullCard>
  );
};

export default React.memo(CommissionsParams);
